import { request } from "../../apis";
import { getUserCurrency } from "../../plugins/utils";

const userCurrency = getUserCurrency()

export const apiGetHelpList = (params) =>
  request("get", `/${userCurrency}/helpcenter`, params, true);